import React from 'react';
import BaseScoreForm from './BaseScoreForm';
import { ScoreDTO } from '../../services/apiClient';
import { ScoreTypeConstants } from '../../constants/ScoreTypeConstants';
import { filterExerciseTypesByCompetition } from '../../utils/filterExerciseTypes';

interface CompetitionScoreFormProps {
  initialValues: ScoreDTO;
  onSubmit: (data: ScoreDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const CompetitionScoreForm: React.FC<CompetitionScoreFormProps> = (props) => {
  return (
    <BaseScoreForm
      {...props}
      exerciseTypeFilter={filterExerciseTypesByCompetition}
      scoreTypeConstant={ScoreTypeConstants.COMPETITION}
      eventTypeMessage={`Event Type: ${props.initialValues.scoreType?.title || 'Competition'} Postal Shoot`}
    />
  );
};

export default CompetitionScoreForm;
